import { useMutation } from "@tanstack/react-query";
import { markPeopleCultureViewed } from "../api/cmsApi";

// Efecto imperativo: marca la pantalla de People & Culture como vista.
export const useMarkPeopleCultureViewed = () =>
  useMutation({ mutationFn: markPeopleCultureViewed });
